module.exports = __webpack_public_path__ + "static/media/logo-fotor-bg-remover-2024071911934.80c469a9.png";